
import { WorksheetFormValues } from "@/components/admin/worksheet/worksheetFormSchema";
import { useWorksheetFetch } from "./worksheetFetch";
import { useWorksheetCreate } from "./worksheetCreate";
import { useWorksheetUpdate } from "./worksheetUpdate";
import { useWorksheetDelete } from "./worksheetDelete";
import { Worksheet } from "./types";

export type { Worksheet };

export const useWorksheetAPI = () => {
  const { fetchWorksheets } = useWorksheetFetch();
  const { createWorksheet } = useWorksheetCreate();
  const { updateWorksheet } = useWorksheetUpdate();
  const { deleteWorksheet } = useWorksheetDelete();

  return {
    fetchWorksheets,
    updateWorksheet,
    createWorksheet,
    deleteWorksheet
  };
};
